import { memo } from 'react'

import { Outlet } from 'react-router-dom'

import ContactAddressCardList from './ContactAddressCardList/ContactAddressCardList'
import ExportContact from './ExportContact/ExportContact'
import FilterContact from './FilterContact/FilterContact'

const ContactAddress = () => {
  

  return (
    <div className="box w-contacts-box">
      <>
        <Outlet />
        <FilterContact />
        <ContactAddressCardList />
        <ExportContact />
      </>
    </div>
  )
}

export default memo(ContactAddress)
